import React from 'react';

export type ProvidePropTypes = Record<string, any>;

// module for transferring all its props to all its children
export class ProvideProps extends React.Component<ProvidePropTypes> {
    public render(): JSX.Element[] {
        const props = this.props;
        const connectContext = (el: any): any => {
            if (!el) {
                return null;
            }

            if (el.props && el.props.children && React.Children.count(el.props.children) > 0) {
                const children: any[] = React.Children.map(el.props.children, connectContext);

                return React.cloneElement(el, {...props, children});
            }

            return React.cloneElement(el, {...props});
        };

        return React.Children.map(this.props.children, connectContext) as JSX.Element[];
    }
}